import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["buttonText", "buttonUse", "options"],
  _excluded3 = ["buttonText", "buttonUse", "subMenuName"];
import { NavMarker } from 'react-rhumb';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useGetFilterOptions, useGetSubMenu } from '../publicCatalogDropdownHooks';
import { getFilterNameFromSubMenuName } from '../publicCatalogDropdownUtils';
import { usePublicCatalogFilters } from '../publicCatalogQueries';
import { subMenuNamesAndOptions } from '../publicCatalogDropdownConstants';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { RefreshIcon } from 'foundations-assets/icons/components/RefreshIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const loadingOption = {
  label: /*#__PURE__*/_jsx(LoadingDots, {}),
  style: {
    pointerEvents: 'none'
  }
};
const errorOption = {
  label: /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.catalogPage.filters.filtersLoadError"
    }), ' ', /*#__PURE__*/_jsx(RefreshIcon, {})]
  }),
  onClick: () => window.location.reload()
};
const DropdownButton = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-on-fill-default",
      children: children
    })
  }));
};
const Dropdown = _ref2 => {
  let {
      buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.catalogPage.filters.browseCatalog"
      }),
      buttonUse = 'tertiary-light',
      options
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(MultiLevelDropdown, Object.assign({
      Button: buttonUse === 'link-on-dark' ? DropdownButton : Button,
      buttonText: buttonText,
      buttonUse: buttonUse,
      minMenuWidth: 250,
      options: options,
      paddingBlock: buttonUse === 'link-on-dark' ? '0' : '500'
    }, rest, {
      autoPlacement: false,
      placement: "bottom"
    }))
  });
};
const PublicCatalogDropdown = _ref3 => {
  let {
      buttonText,
      buttonUse,
      subMenuName
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const {
    filtersData,
    filtersError,
    filtersLoading
  } = usePublicCatalogFilters();
  const getFilterOptions = useGetFilterOptions();
  const getSubMenu = useGetSubMenu();
  if (filtersLoading) {
    return /*#__PURE__*/_jsx(Dropdown, Object.assign({
      buttonText: buttonText,
      buttonUse: buttonUse,
      "data-test-id": "loadingDropdown",
      options: [loadingOption]
    }, rest));
  }
  if (filtersError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "CATALOG_FILTERS_LOAD_FAILURE",
      children: /*#__PURE__*/_jsx(Dropdown, Object.assign({
        buttonText: buttonText,
        buttonUse: buttonUse,
        "data-test-id": "errorDropdown",
        options: [errorOption]
      }, rest))
    });
  }
  let dropdownOptions = [];
  if (!subMenuName) {
    //render all options and submenus (primary menu)
    const getCategoryGroup = () => getFilterOptions('cat', filtersData.subCategories);
    const getToolsGroup = () => getFilterOptions('tools', filtersData.hsSoftwareFilters);
    dropdownOptions = [...getCategoryGroup(), ...getToolsGroup()];
  } else {
    // render submenu only
    const filterName = getFilterNameFromSubMenuName(subMenuName);
    if (!filterName) return null;
    dropdownOptions = getSubMenu(filterName, subMenuName,
    // @ts-expect-error subMenuName can index this object
    subMenuNamesAndOptions[filterName][subMenuName]).options;
  }
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    buttonText: buttonText,
    buttonUse: buttonUse,
    options: dropdownOptions
  }, rest));
};
export default PublicCatalogDropdown;